import { configureStore } from '@reduxjs/toolkit';
import {
    loginReducer,
    colaboradorReducer,
    holeriteReducer,
    informeRendimentosReducer,
    downloadRendimentosReducer,
    bancoHorasReducer,
    periodoFeriasReducer,
    detalhePeriodoFeriasReducer,
    detalheDetalheFeriasReducer,
    beneficiosVtReducer,
    beneficiosVaVrReducer,
    beneficiosPlanoSaudeReducer,
    performanceProdutoReducer
} from './reducers';

const store = configureStore({
    reducer: {
        auth: loginReducer,
        colaborador: colaboradorReducer,
        holerite: holeriteReducer,
        informeRendimentos: informeRendimentosReducer,
        downloadRendimentos: downloadRendimentosReducer,
        bancoHoras: bancoHorasReducer,
        periodoFerias: periodoFeriasReducer,
        detalhePeriodoFerias: detalhePeriodoFeriasReducer,
        detalheFerias: detalheDetalheFeriasReducer,
        beneficiosVt: beneficiosVtReducer,
        beneficiosVaVr: beneficiosVaVrReducer,
        beneficiosPlanoSaude: beneficiosPlanoSaudeReducer,
        performanceProduto: performanceProdutoReducer
    }
});

export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
